import React, { useState } from 'react';
import DropdownPersonalizado from '../Acessorios/Dropdown';
import styles from './Suporte.module.css';
import { useNavigate } from 'react-router-dom';

function Suporte() {

    const [formData, setFormData] = useState({
        assunto: '',
        descricao: ''
    });
    const [erros, setErros] = useState({}); // Estado para armazenar os campos e mensagens de erro
    const navigate = useNavigate();

    const handleDropdownChange = (value) => {
        setFormData({ ...formData, assunto: value });
        if (erros.assunto && value) {
            setErros((prevErros) => ({ ...prevErros, assunto: '' }));
        }
    };

    const handleInputChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
        if (erros[field] && value.trim()) {
            setErros((prevErros) => ({ ...prevErros, [field]: '' }));
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const novosErros = {};

        // Validação dos campos
        if (!formData.assunto) {
            novosErros.assunto = 'Por favor, selecione um assunto.';
        }

        if (!formData.descricao.trim()) {
            novosErros.descricao = 'Por favor, preencha a descrição.';
        }

        // Se houver erros, atualize o estado de erros e não envie o formulário
        if (Object.keys(novosErros).length > 0) {
            setErros(novosErros);
            return;
        }

        // Formata a mensagem para o WhatsApp com quebra de linha
        const mensagemWhatsApp = `*Assunto:* ${formData.assunto}\n*Descrição:* ${formData.descricao}`.trim();

        // Abre o WhatsApp com a mensagem formatada
        const numeroWhatsApp = "5585992720728";
        const urlWhatsApp = `https://wa.me/${numeroWhatsApp}?text=${encodeURIComponent(mensagemWhatsApp)}`;
        window.open(urlWhatsApp, "_blank");

        // Lógica de envio da solicitação de suporte
        console.log("Solicitação de suporte enviada:", formData);

        // Resetar o formulário após o envio
        setFormData({
            assunto: '',
            descricao: ''
        });
        setErros({});
    };

    const handleCancel = () => {
        navigate('/');
    };

    return (
        <div className={styles.formContainer}>
            <form onSubmit={handleSubmit}>
                <div className={styles.instruction}>
                    Você será direcionado para o WhatsApp Web.
                </div>
                <div className={styles.assuntoContainer}>
                    <label className={styles.label} htmlFor="assunto">
                        Assunto:
                        <DropdownPersonalizado
                            options={["Cadastro", "Encomenda", "Armário", "Outro"]}
                            placeholder="Selecione o assunto"
                            onChange={handleDropdownChange}
                            hasError={!!erros.assunto}
                            className={`${styles.inputField}`}
                        />
                    </label>
                    {erros.assunto && <p className={styles.mensagemErro}>{erros.assunto}</p>}
                </div>

                <label className={styles.label} htmlFor="descricao">
                    Descrição:
                    <textarea
                        value={formData.descricao}
                        onChange={(e) => handleInputChange('descricao', e.target.value)}
                        className={`${styles.inputField} ${erros.descricao ? styles.highlightEmpty : ''}`}
                        rows="4"
                        placeholder="Descreva o problema ou questão com detalhes..."
                    />
                </label>
                {erros.descricao && <p className={styles.mensagemErro}>{erros.descricao}</p>}

                <button type="submit" className={styles.submitButton}>Enviar</button>
                <button type="button" className={styles.cancelButton} onClick={handleCancel}>Cancelar</button>
            </form>
        </div>
    );
}

export default Suporte;
